import { render, staticRenderFns } from "./hz.vue?vue&type=template&id=60914af8&scoped=true"
import script from "./hz.vue?vue&type=script&lang=js"
export * from "./hz.vue?vue&type=script&lang=js"
import style0 from "./hz.vue?vue&type=style&index=0&id=60914af8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60914af8",
  null
  
)

export default component.exports